import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface Breadcrumb {
    label: string;
    url: string;
}

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: false
})

export class BreadcrumbsComponent implements OnInit {
    @Input() breadcrumbs: Breadcrumb[] = [];

    constructor(private router: Router, private route: ActivatedRoute) { }

    ngOnInit(): void {
      //  debugger
    }
}
